export default "__VITE_ASSET__C$odE2Ds__"